import { asset } from "@/lib/asset";
import React, { useState } from 'react';
import CaseTemplate from '../components/Cases/CaseTemplate';


const caseNavData = [
  {
    id: 'sber',
    image: asset('/img/partners/sber.svg'),
    style: 'w-[112px] h-[18px]',
    content: {
      title: '«Ключ-АСТРОМ»  обошел конкурентов, включая AppDynamics от Cisco, благодаря своей способности масштабироваться под высокие нагрузки и соответствовать требованиям банка. Система мониторинга включает компоненты для оценки цифрового опыта пользователей, автоматического обнаружения приложений и диагностики, что позволит Сбербанку повысить надежность и эффективность своей ИТ-инфраструктуры.',
      // image: asset('/img/partners/sber-long.png'),
      result: [
      ],
      links: [
        {
          "link": 'https://www.cnews.ru/news/line/2024-08-30_sberteh_i_ruskomtehnologii',
          "caption": "",
          "type": 1
        }
      ]
    }
  },
  {
    id: 'renessans',
    alt: 'РЕНЕССАНС',
    image: asset('/img/partners/renessans-bank.svg'),
    style: 'w-auto h-[28px]',
    content: {
      title: 'Компания «Платформикс» совместно с «Ренессанс Банком» внедрили систему мониторинга цифровых сервисов на базе отечественного решения «Ключ-АСТРОМ». Это позволило банку обеспечить надежный контроль за ИТ-ресурсами, повысить стабильность цифровых сервисов и оперативно реагировать на инциденты. Решение основано на платформе, использующей искусственный интеллект для анализа состояния ИТ-инфраструктуры.',
      image: '',
      result: [
      ],
      links: [
        {
          "link": 'https://www.cnews.ru/news/line/2024-05-23_platformiks_i_renessans',
          "caption": "",
          "type": 1
        }
      ]
    }
  },
  // {
  //   id: 'otkritiye',
  //   alt: 'РЕ',
  //   image: asset('/img/partners/otkritiye.svg'),
  //   style: 'w-[150px] h-[23px]',
  //   content: {
  //     title: '',
  //     image: asset('/img/partners/otkritiye.svg'),
  //     result: [
  //       {
  //         title: 'инцидентов обнаружено за год',
  //         value: '30%'
  //       },
  //       {
  //         title: 'рост исполнения SLA Y2Y',
  //         value: '4,5%'
  //       }
  //     ],
  //     links: []
  //   }
  // },
  {
    id: 'winelab',
    alt: '«ВинЛаб»',
    image: asset('/img/partners/vinlab.svg'),
    style: 'w-auto h-[28px]',
    content: {
      title: 'Компания «ВинЛаб», внедрила  «Ключ-Астром» . Это решение позволило оперативно выявлять и устранять ошибки, отслеживать путь клиента на сайте и анализировать влияние ИТ-показателей на бизнес, что повысило эффективность онлайн-продаж. В результате внедрения время решения проблем сократилось с нескольких дней до часов, а эффективность использования инфраструктуры выросла в 1,5 раза.',
      image: '',
      result: [
      ],
      links: [
        {
          "link": 'https://www.cnews.ru/articles/2023-10-28_kak_klyuch-astrom_pomogaet_onlajn-prodazham?erid=Kra23kmqt',
          "caption": "",
          "type": 1
        }
      ]
    }
  },
  {
    id: 'vtb',
    alt: 'ВТБ',
    image: asset('/img/partners/vtb.svg'),
    style: 'w-auto h-[28px]',
    content: {
      title: "Банк ВТБ внедрил «Ключ Астром» Это решение обеспечивает одновременный контроль всех ключевых систем банка, позволяет оперативно выявлять и устранять проблемы, а также анализировать цифровой опыт пользователей. Внедрение «Ключ Астром» стало частью стратегии ВТБ по технологической трансформации и снижению зависимости от зарубежного программного обеспечения.",
      // image: asset('/img/partners/vtb.svg'),
      result: [
      ],
      links: [
        {
          "link": 'https://plusworld.ru/daily/tehnologii/vtb-vnedril-sistemu-monitoringa-raboty-it-sistem/',
          "caption": "",
          "type": 1
        }
      ]
    }
  },
  {
    id: 'domrf',
    alt: 'ДОМ.РФ',
    image: asset('/img/partners/domrf.svg'),
    style: 'w-auto h-[28px]',
    content: {
      title: 'Банк ДОМ.РФ внедрил  «Ключ-АСТРОМ» для контроля своих информационных систем. Это решение позволило банку оперативно отслеживать производительность цифровых сервисов, выявлять и устранять инциденты, а также обеспечивать высокую надежность ИТ-инфраструктуры.',
      // image: asset('/img/partners/domrf.png'),
      result: [
      ],
      links: [
        {
          "link": 'https://vc.ru/domrf/563279-tri-keisa-monitoringa-informacionnyh-sistem-banka-domrf-s-pomoshyu-klyuch-astrom?__cf_chl_tk=AM_58_q8Qy_euAAaNk0n0Ztxv0_6K6VosrTS8FwfBd8-1706260536-0-gaNycGzNDzs&ysclid=m9l2c4ggjl118366188',
          "caption": "",
          "type": 1
        }
      ]
    }
  },
  {
    id: 'mkb',
    alt: 'МКБ',
    image: asset('/img/partners/mkb.svg'),
    style: 'w-auto h-[28px]',
    content: {
      title: 'МКБ удалось существенно сократить время на поиск ошибок в наиболее критичных ИТ-системах, выявить узкие места в сквозныхсквозных процессах, улучшить качество и производительность ИТ-систем банка.',
      // image: asset('/img/partners/mkb.svg'),
      result: [
      ],
      links: [
        {
          "link": 'https://mkb.ru/news/59681',
          "caption": "",
          "type": 1
        },
        {
          "link": 'https://habr.com/ru/amp/publications/863816/ ',
          "caption": "Habr",
          "type": 1
        },
        {
          "link": 'https://globalcio.ru/news/31214/',
          "caption": "Globalcio",
          "type": 1
        }
      ]
    }
  },
  // {
  //   id: 'rosbank',
  //   alt: 'РОСБАНК',
  //   image: asset('/img/partners/rosbank.svg'),
  //   style: 'w-[64px] h-[15px]',
  //   content: {
  //     title: 'РОСБАНК',
  //     image: asset('/img/partners/rosbank.svg'),
  //     result: [
  //     ],
  //     links: []
  //   }
  // }

];

function Cases() {
  const [activeCase, setActiveCase] = useState('sber');

  const ActiveComponent = caseNavData.find(item => item.id === activeCase)?.component;

  return (
    <div className='w-full bg-white overflow-hidden'>
      <div className='container mx-auto px-4 py-8 my-[98px]'>
        {/* Navigation - Updated to fill width */}
        <div className="text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-3xl font-bold font-['Open Sans']">Кейсы</div>

        <div className="w-full flex justify-center mb-8 mt-[40px] xl:mt-[55px] overflow-hidden">
          <div className='sm-no-scrollbar overflow-x-auto'>
            <nav className="min-w-[1167px] w-[1167px] flex justify-between items-between h-[53px]">
              {caseNavData.map((caseItem) => (
                <button
                  key={caseItem.id}
                  onClick={() => setActiveCase(caseItem.id)}
                  className={`relative pb-[8px] transition-all duration-300 flex-1 mx-2 first:ml-0 last:mr-0 px-3 ${activeCase === caseItem.id ? '' : 'opacity-50'
                    }`}
                >
                  <img
                    src={caseItem.image}
                    alt={`${caseItem.alt}`}
                    className={`${caseItem.style} object-contain mx-auto transition-all duration-300 ${activeCase === caseItem.id ? 'grayscale-0' : 'grayscale'
                      }`}
                  />
                  <div
                    className={`absolute bottom-0 left-0 w-full h-[2px] transition-all duration-300 ${activeCase === caseItem.id ? 'bg-[#c0834d]' : 'bg-gray-300'
                      }`}
                  />
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Content */}
        <div className="flex justify-center mt-[40px]">
          <div className="w-[98%] sm:w-[604px] lg:w-[1000px] xl:w-[1000px] flex flex-row min-h-[380px] p-5 bg-white rounded-2xl shadow-[0px_0px_10.899999618530273px_0px_rgba(0,0,0,0.25)] justify-between items-start inline-flex">
            {activeCase && <CaseTemplate content={caseNavData.find(item => item.id === activeCase)?.content} />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cases; 